<template>
    <div
        :class="item.click === undefined ? 'headerDefault' : 'headerDefaultPointer'"
        v-bind:style="item.style"
        @click="item.click === undefined ? '' : item.click($event, item)"
    >
        <span>
          {{item.keyTitle}}
        </span>
      <div class="hover">
        ↑↓
      </div>
    </div>
</template>
<script>
    export default {
        name: 'TableTypeHeaderDefault',
        props: ['item'],
    }
</script>
<style lang="scss">
.hover{
  display: none;
  position: absolute;
  top: 2px;
  right: 2px;
  transition: background-color 0.5s;
  background-color: #f7fbff;
  opacity: 0.8;
  padding: 5px;
  border-radius: 5px;
}

.headerDefaultPointer {
  &:hover {
    position: relative;

    cursor: pointer;

    .hover {
      display: block;
    }
  }
}
</style>